import React from "react";
import { useNavigate } from "react-router-dom";
import { CButton, CContainer } from "@coreui/react-pro";
import PublicSiteShell from "../../components/public/PublicSiteShell";
import "../../styles/public-experience.css";
import "../../styles/public-family-alignment.css";

const sections = [
  {
    title: "Hinweis zum Stand",
    content:
      "Die Allgemeinen Geschäftsbedingungen für Experts4Europe werden derzeit final redaktionell und rechtlich abgestimmt. Bis zur Veröffentlichung der endgültigen Fassung gelten die jeweils individuell vereinbarten Bedingungen sowie die auf den betreffenden Seiten sichtbaren Hinweise.",
  },
  {
    title: "Geltungsbereich",
    content:
      "Die künftigen AGB werden die Nutzung der öffentlichen Website, der Bewerber- und Arbeitgeberbereiche sowie der damit verbundenen digitalen Dienste von Experts4Europe regeln.",
  },
  {
    title: "Kontakt",
    content:
      "Fragen zu vertraglichen Rahmenbedingungen, Zusammenarbeit oder rechtlichen Hinweisen können an Info@Experts4Europe.com gerichtet werden.",
  },
];

export default function AGB() {
  const navigate = useNavigate();

  const hero = (
    <section className="public-legal-hero">
      <CContainer fluid className="public-core-container public-legal-shell public-page-shell">
        <div className="public-legal-hero__panel public-page-hero-panel">
          <div className="public-legal-hero__copy">
            <span className="public-core-eyebrow public-page-overline">AGB</span>
            <h1 className="public-page-title">Allgemeine Geschäftsbedingungen</h1>
            <p className="public-legal-hero__lead public-page-body">
              Diese Seite zeigt den aktuell gültigen öffentlichen Stand zu den Allgemeinen
              Geschäftsbedingungen von Experts4Europe. Bis zur Veröffentlichung der finalen
              Fassung bleiben individuell vereinbarte Bedingungen und die jeweils sichtbaren
              Nutzungshinweise maßgeblich.
            </p>
            <div className="public-legal-chip-row">
              <span>Öffentliche Website</span>
              <span>Fachkräfte</span>
              <span>Arbeitgeber</span>
            </div>
          </div>

          <aside className="public-legal-hero__meta">
            <div className="public-legal-callout public-page-callout">
              <strong>Status</strong>
              <span>aktuelle öffentliche Vorabfassung</span>
            </div>
            <div className="public-legal-callout public-page-callout">
              <strong>Kontakt</strong>
              <a href="mailto:Info@Experts4Europe.com">Info@Experts4Europe.com</a>
            </div>
            <div className="public-legal-callout public-page-callout">
              <strong>Veröffentlichung</strong>
              <span>Die finale Fassung wird nach redaktioneller und rechtlicher Freigabe an dieser Stelle veröffentlicht.</span>
            </div>
          </aside>
        </div>
      </CContainer>
    </section>
  );

  return (
    <PublicSiteShell pageClassName="public-legal-page" hero={hero}>
      <section className="public-core-band public-core-band--neutral">
        <CContainer fluid className="public-core-container public-legal-shell public-page-shell">
          <div className="public-legal-card public-page-card">
            <span className="public-core-eyebrow public-page-overline">Schnellüberblick</span>
            <div className="public-legal-basis-grid public-legal-basis-grid--compact">
              <article className="public-legal-basis-card public-page-value-card">
                <h3>Worum es aktuell geht</h3>
                <p>
                  Der derzeitige Stand beschreibt den öffentlichen Nutzungsrahmen für Website,
                  Fachkräfte- und Arbeitgeberzugänge, solange die finale AGB-Fassung noch in der
                  Abstimmung ist.
                </p>
              </article>
              <article className="public-legal-basis-card public-page-value-card">
                <h3>Was bereits gilt</h3>
                <p>
                  Maßgeblich bleiben die konkret sichtbaren Hinweise in den jeweiligen Bereichen
                  sowie individuell vereinbarte Bedingungen im jeweiligen Vertragskontext.
                </p>
              </article>
              <article className="public-legal-basis-card public-page-value-card">
                <h3>Wo Rückfragen hingehen</h3>
                <p>
                  Vertrags- und Rahmenfragen können jederzeit an{" "}
                  <a href="mailto:Info@Experts4Europe.com">Info@Experts4Europe.com</a>{" "}
                  gerichtet werden.
                </p>
              </article>
            </div>
          </div>
        </CContainer>
      </section>

      <section className="public-core-band public-core-band--light">
        <CContainer fluid className="public-core-container public-legal-shell public-page-shell">
          <div className="public-legal-stack">
            {sections.map((section) => (
              <article key={section.title} className="public-legal-card public-page-card">
                <h2>{section.title}</h2>
                <div className="public-legal-richtext public-page-richtext">
                  <p>{section.content}</p>
                </div>
              </article>
            ))}
          </div>

          <div className="public-legal-nav public-page-card">
            <div className="public-legal-nav__copy">
              <span className="public-core-eyebrow public-page-overline">Rechtliche Seiten</span>
              <h2 className="public-page-subtitle">Weitere öffentliche Rechts- und Pflichtangaben</h2>
              <p className="public-page-body public-page-body--muted">
                Impressum, Datenschutz und AGB bleiben als ruhige, konsistente Public-Family-Seiten
                direkt erreichbar.
              </p>
            </div>
            <div className="public-legal-nav__actions">
              <CButton type="button" className="public-core-btn public-core-btn--subtle" onClick={() => navigate("/impressum")}>
                Impressum
              </CButton>
              <CButton type="button" className="public-core-btn public-core-btn--ghost" onClick={() => navigate("/datenschutz")}>
                Datenschutz
              </CButton>
            </div>
          </div>
        </CContainer>
      </section>
    </PublicSiteShell>
  );
}
